// extracted by mini-css-extract-plugin
export var deleteModal = "_k6-0";